// ../js-utils/dist/chunk-KKPXSPBY.mjs
var flipObject = (obj) => Object.keys(obj).reduce((newObject, key) => {
  newObject[obj[key]] = isNaN(+key) ? key : +key;
  return newObject;
}, {});

// src/storybookCommonArgTypes.tsx
import { jsx } from "react/jsx-runtime";
var getIconSelectArgType = (icons, iconSize = 20) => ({
  control: { type: "select" },
  mapping: Object.entries({ ...icons }).reduce((accumulator, [key, Icon]) => {
    return {
      ...accumulator,
      [key]: /* @__PURE__ */ jsx(Icon, { height: iconSize, width: iconSize })
    };
  }, {}),
  options: Object.keys(icons)
});
var getColorSelectArgType = (color) => {
  const colorsIncludingNullOption = {
    "Remove (and inherit from toolbar)": null,
    ...color
  };
  return {
    control: {
      type: "select",
      labels: flipObject(colorsIncludingNullOption)
    },
    options: Object.values(colorsIncludingNullOption)
  };
};

// src/storybookComponents.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function StorybookDocGrid(props) {
  const { children } = props;
  return /* @__PURE__ */ jsx2("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 30 }, children });
}

// src/EnvironmentManager/EnvironmentManager.config.ts
var DEFAULT_ENVIRONMENT = "development";
var REQUEST_TIMEOUT_MS = 5e3;
var EnvironmentsMatchers = [
  // a1
  {
    predicate: (envName) => envName === "systemintegration",
    availableEnvironments: [
      "systemintegration",
      "sitAlnova",
      "sitBrowserStack"
    ]
  },
  // d1
  {
    predicate: (envName) => envName === "development",
    availableEnvironments: ["development", "developmentAlnova"]
  },
  // s1
  {
    predicate: (envName) => envName === "staging",
    availableEnvironments: ["stagingBrowserStack", "staging", "stagingAlnova"]
  },
  // s2
  {
    predicate: (envName) => envName === "staging-performance",
    availableEnvironments: ["stagingPerf", "stagingPerfAlnova"]
  },
  // s3
  {
    predicate: (envName) => envName === "stagingDemo",
    availableEnvironments: ["stagingDemo", "stagingDemoAlnova"]
  },
  {
    predicate: () => true,
    availableEnvironments: []
  }
];

// ../banking-api/src/constants.ts
var ENVS = [
  "development",
  "developmentAlnova",
  "developmentWeb",
  "staging",
  "stagingBrowserStack",
  "stagingAlnova",
  "stagingPerf",
  "stagingPerfAlnova",
  "stagingDemo",
  "stagingDemoAlnova",
  "test",
  "systemintegration",
  "sitAlnova",
  "sitBrowserStack",
  "uat",
  "uatAlnova",
  "sandbox",
  "production",
  "pact"
];
var PEGA_ADS_PREFIXES = {
  developmentWeb: "http://localhost:3000/pega",
  /*developmentWeb:
    "https://bit-cee-stg1.pegacloud.net/prweb/api/PegaMKTContainer/V3",
    */
  development: "https://bit-cee-dt1.pegacloud.net/prweb/api/PegaMKTContainer/V3",
  staging: "https://bit-cee-stg1.pegacloud.net/prweb/api/PegaMKTContainer/V3"
};
var REACT_CMS_PREFIXES = {
  development: "https://react-cms.sandbox.boiapplications.com"
};
var URL_PREFIXES = {
  developmentWeb: "http://localhost:3000/api",
  development: "https://api.d1.cdc365dev.boicssp.net",
  developmentAlnova: "https://alnovatest.boi.com:8171",
  staging: "https://api.s1.cdc365st.boicssp.net",
  stagingPerf: "https://api.s2.cdc365st.boicssp.net",
  stagingPerfAlnova: "https://alnovatest.boi.com:8175",
  stagingDemo: "https://api.s3.cdc365st.boicssp.net",
  stagingDemoAlnova: "https://alnovatest.boi.com:8181",
  stagingBrowserStack: "https://api.s1.cdc365st.boicloudtest.net",
  stagingAlnova: "https://alnovatest.boi.com:8173",
  systemintegration: "https://api.a1.cdc365sit.boicssp.net",
  sitAlnova: "https://alnovatest.boi.com:8177",
  sitBrowserStack: "https://api.a1.cdc365sit.boicloudtest.net",
  uat: "https://api.u1.cdc365uat.boicssp.net",
  uatAlnova: "https://alnovatest.boi.com:8179",
  sandbox: "https://api.dev.bkiemob.com",
  production: "",
  test: "https://api.dev.react.boicssp.net",
  pact: "http://127.0.0.1:61263"
};
var ENDPOINTS = ENVS.reduce((accumulator, env) => {
  const urlPrefix = URL_PREFIXES[env];
  const pegaPrefix = PEGA_ADS_PREFIXES[env] || PEGA_ADS_PREFIXES["staging"];
  const reactCMSPRefix = REACT_CMS_PREFIXES[env] || REACT_CMS_PREFIXES["development"];
  const envEndpoints = {
    base: () => {
      return urlPrefix;
    },
    loginUser: () => {
      return `${urlPrefix}/login-user/`;
    },
    getScaStatus: () => {
      return `${urlPrefix}/sca/sca`;
    },
    getSecurityDevices: () => {
      return `${urlPrefix}/get-security-devices/`;
    },
    initiateCustomerRegistration: () => {
      return `${urlPrefix}/registration/initiate-customer-registration`;
    },
    validateCustomerForRegistration: () => {
      return `${urlPrefix}/registration/validate-customer-for-registration`;
    },
    completeRegistration: () => {
      return `${urlPrefix}/registration/complete-registration`;
    },
    finaliseRegistration: () => {
      return `${urlPrefix}/registration/finalise-registration`;
    },
    getRegisteredAccounts: () => {
      return `${urlPrefix}/account/retrieve-registered-accounts`;
    },
    getCustomer: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/customer-mock" : "/customer"}/customers/b365-id`;
    },
    getCustomerAccounts: () => `${urlPrefix}/account/customers/b365-id/accounts`,
    addCustomerAccount: () => `${urlPrefix}/account/customers/b365-id/accounts/id`,
    sendWithdrawFundsForm: () => `${urlPrefix}/account/customers/b365-id/accounts/withdraw-funds`,
    orderStatement: () => `${urlPrefix}/account/customers/b365-id/accounts/id/statements/orders`,
    updateEmailAddress: () => `${urlPrefix}/customer/customers/b365-id/email`,
    generateMobileNumberOTP: () => `${urlPrefix}/customer/customers/b365-id/mobile/otp`,
    updateMobileNumber: () => `${urlPrefix}/customer/customers/b365-id/mobile`,
    updateAccountNickname: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/account-mock" : "/account"}/customers/b365-id/accounts/retail-accounts/id/nickname`;
    },
    updateAccountAlerts: () => `${urlPrefix}/account/customers/b365-id/accounts/overdraft-alerts`,
    getRetailAccountSummaryDetails: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/account-mock" : "/account"}/customers/b365-id/accounts/retail-accounts/id/summary-details`;
    },
    getCreditCardAccountSummaryDetails: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/account-mock" : "/account"}/customers/b365-id/accounts/credit-card-accounts/id/summary-details`;
    },
    getRetailStatementList: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/statement-mock" : "/statement"}/customers/b365-id/accounts/retail-accounts/id/statements/get`;
    },
    getCCStatementList: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/statement-mock" : "/statement"}/customers/b365-id/accounts/credit-card-accounts/id/statements/get`;
    },
    getRetailStatementFile: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/statement-mock" : "/statement"}/customers/b365-id/accounts/retail-accounts/id/statements/id/file/get`;
    },
    getCCStatementFile: (useMockEndpoint = false) => {
      return `${urlPrefix}${useMockEndpoint ? "/statement-mock" : "/statement"}/customers/b365-id/accounts/credit-card-accounts/id/statements/id/file/get`;
    },
    getCustomerConsents: ({
      consentType,
      jurisdiction,
      status,
      page,
      pageSize
    }) => {
      const url = new URL(urlPrefix);
      url.pathname += "customer/customers/b365-id/consents";
      url.searchParams.append("consentType", consentType);
      url.searchParams.append("jurisdiction", jurisdiction);
      url.searchParams.append("status", status);
      pageSize && url.searchParams.append("pageSize", String(pageSize));
      page && url.searchParams.append("page", String(page));
      return url.href;
    },
    customerConsentDetails: (uniqueIdentifier, { consentType, jurisdiction, status }) => {
      const url = new URL(urlPrefix);
      url.pathname += "customer/customers/b365-id/consents/";
      if (uniqueIdentifier) {
        url.pathname += uniqueIdentifier;
      }
      url.searchParams.append("consentType", consentType);
      url.searchParams.append("jurisdiction", jurisdiction);
      url.searchParams.append("status", status);
      return url.href;
    },
    getCustomerFundsHistory: (uniqueIdentifier, { consentType, jurisdiction, status, page, pageSize }) => {
      const url = new URL(urlPrefix);
      url.pathname += "customer/customers/b365-id/consents/";
      if (uniqueIdentifier) {
        url.pathname += uniqueIdentifier;
      }
      url.pathname += "/funds-check";
      url.searchParams.append("consentType", consentType);
      url.searchParams.append("jurisdiction", jurisdiction);
      url.searchParams.append("status", status);
      pageSize && url.searchParams.append("pageSize", String(pageSize));
      page && url.searchParams.append("page", String(page));
      return url.href;
    },
    getTransactionList: () => {
      return `${urlPrefix}/transaction/customers/b365-id/accounts/retail-accounts/id/transactions/get`;
    },
    getCompletedTransactionList: (queryParams) => {
      const url = new URL(
        `${urlPrefix}/transaction/customers/b365-id/accounts/retail-accounts/id/completed-transactions/get`
      );
      Object.entries(queryParams).forEach(([key, value]) => {
        url.searchParams.append(key, value);
      });
      return url.href;
    },
    getCreditCardTransactionList: () => {
      return `${urlPrefix}/transaction/customers/b365-id/accounts/credit-card-accounts/id/transactions/get`;
    },
    getTransactionFilterOptions: () => {
      return `${urlPrefix}/transaction/filter-options`;
    },
    downloadNonFilteredTransactionCSV: () => {
      return `${urlPrefix}/transaction/customers/b365-id/accounts/retail-accounts/id/transactions/get`;
    },
    downloadFilteredTransactionCSV: (queryParams) => {
      const url = new URL(
        `${urlPrefix}/transaction/customers/b365-id/accounts/retail-accounts/id/completed-transactions/get`
      );
      Object.entries(queryParams).forEach(([key, value]) => {
        url.searchParams.append(key, value);
      });
      return url.href;
    },
    // TODO: [MockEndpoints] Should be changed when endpoints will be worked without mocks
    getStatementSettings: (useMockEndpoint = false) => {
      return `${urlPrefix}/${useMockEndpoint ? "customer-mock" : "customer"}/customers/b365-id/statement-settings`;
    },
    getStatementAccountList: (useMockEndpoint = false, queryParam) => {
      return `${urlPrefix}${useMockEndpoint ? "/account-mock" : "/account"}/customer/b365-id/services/accounts?service=${queryParam}`;
    },
    getServicesAccountsList: (queryParam) => {
      const url = new URL(urlPrefix);
      url.pathname += "account/customer/b365-id/services/accounts";
      queryParam && url.searchParams.append("service", queryParam);
      return url.href;
    },
    updateNotificationMethod: (useMockEndpoint = false) => {
      return `${urlPrefix}/${useMockEndpoint ? "customer-mock" : "customer"}/customers/b365-id/statement-settings/notification-method`;
    },
    updateStatementDeliveryType: () => {
      return `${urlPrefix}/customer/customers/b365-id/statement-settings/accounts/id/delivery-type`;
    },
    // Authorization
    validateCustomer: () => {
      return `${urlPrefix}/authentication/validate-customer`;
    },
    /** @deprecated: Web/App login endpoints will be merged  */
    initiateMobileLogin: () => {
      return `${urlPrefix}/authentication/initiate-mobile-login`;
    },
    /** @deprecated: Web/App login endpoints will be merged  */
    completeLogin: () => {
      return `${urlPrefix}/authentication/complete-login`;
    },
    // TODO: should be removed when decryptor for tokens will be done
    temporaryCompleteLogin: (userId) => {
      return `${urlPrefix}/authentication/restricted/token/${userId}`;
    },
    /** @deprecated: Web/App login endpoints will be merged  */
    authenticateCustomerForLogin: () => {
      return `${urlPrefix}/authentication/authenticate-customer-for-login`;
    },
    revokeToken: () => {
      return `${urlPrefix}/authentication/revoke`;
    },
    /** @deprecated: Web/App login endpoints will be merged  */
    authenticateWebLogin: () => {
      return `${urlPrefix}/authentication/authenticate-desktop-login`;
    },
    /** @deprecated: Web/App login endpoints will be merged  */
    completeWebLogin: () => {
      return `${urlPrefix}/authentication/complete-desktop-login`;
    },
    customerPostalAddress: () => {
      return `${urlPrefix}/customer/customers/b365-id/postal-address`;
    },
    getPegaContainers: () => `${pegaPrefix}/Container`,
    addPegaCaptureResponse: () => `${pegaPrefix}/CaptureResponse`,
    generateLifeOnlineLink: () => {
      return `${urlPrefix}/account/generate-life-online-link`;
    },
    getExtendedTransactionDetails: () => {
      return `${urlPrefix}/transaction/customers/b365-id/accounts/id/transactions/id/extended-details/get`;
    },
    getCardList: () => `${urlPrefix}/cards/customers/b365-id/cards`,
    getCardPin: () => `${urlPrefix}/cards/customers/b365-id/cards/pin/get`,
    updateCardFreezeState: (id) => `${urlPrefix}/cards/${id}/frozen`,
    updateCardSpendAlertsState: () => `${urlPrefix}/cards/set-spend-alerts`,
    getCustomerDevices: () => `${urlPrefix}/device-management/customers/b365-id/devices`,
    updateDeviceStatus: () => `${urlPrefix}/device-management/customers/b365-id/devices/device-id/status`,
    updateDeviceNickname: () => `${urlPrefix}/device-management/customers/b365-id/devices/device-id/nickname`,
    deleteDevice: () => `${urlPrefix}/device-management/customers/b365-id/devices/device-id/delete`,
    getReactCMSPages: () => {
      return `${reactCMSPRefix}/wp-json/wp/v2/content-page`;
    },
    getPayeeList: (queryParams) => {
      const url = new URL(`${urlPrefix}/payee/customers/b365-id/payees/get`);
      Object.entries(queryParams).forEach(([key, value]) => {
        url.searchParams.append(key, value);
      });
      return url.href;
    },
    getPayeeOptionValues: () => `${urlPrefix}/payee/customers/b365-id/payees/option-values/get`,
    deletePayee: () => `${urlPrefix}/payee/customers/b365-id/payees/id/delete`,
    amendDirectDebit: () => {
      return `${urlPrefix}/account/customers/b365-id/accounts/direct-debits/amendments`;
    },
    getPayerAccountStandingOrders: () => {
      return `${urlPrefix}/standing-order/customers/b365-id/accounts/id/standing-orders/get`;
    },
    validatePayerAccountStandingOrder: () => {
      return `${urlPrefix}/standing-order/customers/b365-id/accounts/id/standing-orders/validations`;
    },
    getAvailableContacts: () => {
      return `${urlPrefix}/mobile-payments/customers/b365-id/contacts/available-contacts/get`;
    },
    getMobileNumberStatus: () => {
      return `${urlPrefix}/mobile-payments/customers/b365-id/contacts/mobile-number/status/get`;
    },
    getBlockedContacts: () => {
      return `${urlPrefix}/mobile-payments/customers/b365-id/contacts/blocked-contacts`;
    },
    updateBlockedContacts: () => {
      return `${urlPrefix}/mobile-payments/customers/b365-id/contacts/mobile-number/blocked`;
    },
    createNewStandingOrder: () => {
      return `${urlPrefix}/standing-order/customers/b365-id/accounts/id/standing-orders`;
    },
    updateStandingOrder: () => {
      return `${urlPrefix}/standing-order/customers/b365-id/accounts/id/standing-orders/id`;
    },
    getLoginAlerts: () => {
      return `${urlPrefix}/cms/alerts/latest`;
    }
  };
  const endpoints = {
    ...accumulator,
    [env]: envEndpoints
  };
  return endpoints;
}, {});

// src/EnvironmentManager/EnvironmentManager.ts
var EnvironmentManager = class {
  initialEnvironment;
  availableEnvironments;
  constructor(environmentName) {
    this.initialEnvironment = environmentName ?? DEFAULT_ENVIRONMENT;
    const foundEnvironmentMatcher = EnvironmentsMatchers.find(
      ({ predicate }) => predicate(this.initialEnvironment)
    );
    this.availableEnvironments = foundEnvironmentMatcher?.availableEnvironments ?? [];
  }
  async getEffectiveEnvironment() {
    const envTestCalls = this.getTestCalls();
    try {
      const envResponses = await Promise.allSettled(envTestCalls);
      const successfulEnv = envResponses.find(
        (envResponse) => envResponse.status === "fulfilled"
      )?.value;
      if (successfulEnv) {
        console.log(
          `[EnvironmentManager] :: Environment set to: ${successfulEnv}`
        );
        return successfulEnv;
      }
      console.log(
        `[EnvironmentManager] :: no fulfilled requests, using ${this.initialEnvironment} as fallback`
      );
      return this.initialEnvironment;
    } catch (error) {
      console.error(
        "[EnvironmentManager] :: Error during environment detection:",
        error
      );
      return this.initialEnvironment;
    }
  }
  getTestCalls() {
    const abortController = new AbortController();
    return this.availableEnvironments.map(
      (env) => new Promise((resolve, reject) => {
        console.log(
          `[EnvironmentManager] :: Testing environment "${env}" ...`
        );
        this.fetchWithTimeout({
          url: `${URL_PREFIXES[env]}/test`,
          options: {
            signal: abortController.signal,
            mode: "no-cors"
          },
          timeout: REQUEST_TIMEOUT_MS
        }).then(() => {
          console.log(
            `[EnvironmentManager] :: Environment "${env}" is available`
          );
          abortController.abort("Aborted");
          resolve(env);
        }).catch((error) => {
          console.log(
            `[EnvironmentManager] :: Environment "${env}" unavailable: ${error}`
          );
          reject(error);
        });
      })
    );
  }
  async fetchWithTimeout({
    url,
    options,
    timeout
  }) {
    return Promise.race([
      fetch(url, options),
      new Promise(
        (_, reject) => setTimeout(
          () => reject(new Error(`Request timeout for ${url}`)),
          timeout
        )
      )
    ]);
  }
};

// src/forwardRefGenerics.ts
import { forwardRef } from "react";
var forwardRefGenerics = forwardRef;
export {
  EnvironmentManager,
  StorybookDocGrid,
  forwardRefGenerics,
  getColorSelectArgType,
  getIconSelectArgType
};
